import type { StatesConfig } from 'xstate'
import type { TStep } from 'src/types'
import { getIntellio2LwResumeTarget } from 'cohorts/intl_2lw/helpers/getIntellio2LwResumeTarget'
import { getComplianceVersion } from 'helpers/getComplianceVersion'
import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'
import { useZustandGlobalStore } from 'zustandGlobalStore'
import { PageId } from 'constants/pages'

const isComplianceFlow = (): boolean => getComplianceVersion() !== null

const isUpsellCheckout = (): boolean =>
  useZustandGlobalLocalStore.getState().checkoutContext === 'upsell'

export const getXStateConfigWoofzInt2Lw = (
  pages: TStep[],
): StatesConfig<any, any, any> => ({
  initial: {
    always: [
      {
        target: getIntellio2LwResumeTarget(pages),
      },
    ],
  },
  ...pages.reduce(
    (acc, page, index) => ({
      ...acc,
      [page.pageId]: {
        on: {
          NEXT_FLOW_STEP: {
            target: pages[index + 1]?.pageId,
          },
          PREVIOUS_FLOW_STEP: {
            target:
              index - 1 >= 0 ? pages[index - 1].pageId : pages[index].pageId,
          },
          SKIP_ONE_STEP: {
            target:
              index + 2 < pages.length
                ? pages[index + 2].pageId
                : pages[index].pageId,
          },
          SKIP_ONE_STEP_BACK: {
            target:
              index - 2 >= 0 ? pages[index - 2].pageId : pages[index].pageId,
          },
          POST_PAYMENT_CONTINUE: {
            target: PageId.REGISTRATION_INTL_2LW,
          },
          ...(page.pageId === PageId.EMAIL_INTL_2LW && {
            PREVIOUS_FLOW_STEP: [
              {
                cond: isComplianceFlow,
                target: PageId.EDUCATION_QUESTION_INTL_2LW,
              },
              { target: PageId.DISCOVER_FEEDBACKS_INTL_2LW },
            ],
          }),
          ...(page.pageId === PageId.OFFER_INTL_2LW && {
            NEXT_FLOW_STEP: [
              { cond: isComplianceFlow, target: PageId.CHECKOUT_INTL_2LW },
              { target: PageId.PAYMENT_INTL_2LW },
            ],
            PREVIOUS_FLOW_STEP: [
              { cond: isComplianceFlow, target: PageId.EMAIL_CONSENT_INTL_2LW },
              { target: PageId.EMAIL_INTL_2LW },
            ],
            POST_PAYMENT_CONTINUE: { target: PageId.UPSELL_INTL_2LW },
          }),
          ...(page.pageId === PageId.CANCEL_OFFER_INTL_2LW && {
            NEXT_FLOW_STEP: [
              { cond: isComplianceFlow, target: PageId.CHECKOUT_INTL_2LW },
              { target: PageId.PAYMENT_INTL_2LW },
            ],
          }),
          ...(page.pageId === PageId.PAYMENT_INTL_2LW && {
            NEXT_FLOW_STEP: { target: PageId.UPSELL_INTL_2LW },
            PREVIOUS_FLOW_STEP: [
              {
                cond: (): boolean =>
                  !!useZustandGlobalStore.getState()
                    .hasVisitedCancelOfferIntl2Lw,
                target: PageId.CANCEL_OFFER_INTL_2LW,
              },
              { target: PageId.SPECIAL_DISCOUNT_INTL_2LW },
            ],
            POST_PAYMENT_CONTINUE: { target: PageId.UPSELL_INTL_2LW },
          }),
          ...(page.pageId === PageId.CHECKOUT_INTL_2LW && {
            NEXT_FLOW_STEP: [
              { cond: isUpsellCheckout, target: PageId.REGISTRATION_INTL_2LW },
              { target: PageId.UPSELL_INTL_2LW },
            ],
            PREVIOUS_FLOW_STEP: [
              { cond: isUpsellCheckout, target: PageId.UPSELL_INTL_2LW },
              {
                cond: (): boolean =>
                  !!useZustandGlobalStore.getState()
                    .hasVisitedCancelOfferIntl2Lw,
                target: PageId.CANCEL_OFFER_INTL_2LW,
              },
              { target: PageId.SPECIAL_DISCOUNT_INTL_2LW },
            ],
            POST_PAYMENT_CONTINUE: [
              { cond: isUpsellCheckout, target: PageId.REGISTRATION_INTL_2LW },
              { target: PageId.UPSELL_INTL_2LW },
            ],
          }),
          ...(page.pageId === PageId.UPSELL_INTL_2LW && {
            NEXT_FLOW_STEP: [
              { cond: isUpsellCheckout, target: PageId.CHECKOUT_INTL_2LW },
              { target: PageId.REGISTRATION_INTL_2LW },
            ],
          }),
        },
      },
    }),
    {},
  ),
  // [PageId.DOWNLOAD_ESA_INTL_2LW]: {
  //   type: 'final',
  // },
})
